/**
 * Opções de polling compartilhadas por toda query de tempo real do app — GUPM-234.
 *
 * Por que um helper e não `refetchInterval: DASHBOARD_POLLING_MS` em cada query:
 * eram 14 pontos declarando o intervalo cru, e todos os 14 paravam de pollar quando
 * a aba saía de foco. Medido no browser com duas abas em 04/08/2026: aba `hidden`
 * ficou 58 s sem uma única requisição. Com o broadcast `tarp:critical` também
 * quebrado (tópico errado, corrigido neste mesmo card), a aba em segundo plano não
 * recebia atualização por caminho nenhum — e é exatamente assim que o vigilante e o
 * RT deixam o app aberto durante o plantão.
 *
 * Centralizar também dá um lugar único para a decisão evoluir: quando o GUPM-244
 * (emissão via `realtime.send` no banco) entrar, o polling volta a ser só rede de
 * segurança e o número pode subir — em 1 arquivo, não em 14.
 *
 * A borda do DOM mora aqui de propósito: `src/domain/` é TS puro e não pode ler
 * `document` (regra de arquitetura #1).
 */
import { pollingIntervalMs } from '@/domain/conformidade/anm';

/** `true` quando a aba está em segundo plano. Fora do browser (SSR/teste), visível. */
function abaOculta(): boolean {
  return typeof document !== 'undefined' && document.hidden;
}

export const pollingQueryOptions = {
  /**
   * Função, não número: o TanStack reavalia a cada tick, então a troca
   * visível↔oculta vale no ciclo seguinte, sem remontar a query nem escutar
   * `visibilitychange`.
   */
  refetchInterval: (): number => pollingIntervalMs(abaOculta()),
  /**
   * Sem isto o intervalo acima é ignorado com a aba oculta — o default do TanStack
   * é `false`, que PAUSA o polling em segundo plano. É a flag que fecha o buraco.
   */
  refetchIntervalInBackground: true,
} as const;
